import { DiscussionPage } from '../DiscussionPage/loadable';
import { MediaPage } from '../MediaPage/loadable';
import { AboutPage } from '../AboutPage/loadable';
import { EventsPage } from '../EventsPage/loadable';
import { MembersPage } from '../MembersPage/loadable';
import { FilesPages } from '../FilesPage/loadable';
import { CustomTabPage } from '../CustomTabPage/loadable';

export const ROUTES = [
  {
    state: 'group.discussion',
    component: DiscussionPage,
  },
  {
    state: 'group.media',
    component: MediaPage,
  },
  {
    state: 'group.files',
    component: FilesPages,
  },
  {
    state: 'group.about',
    component: AboutPage,
  },
  {
    state: 'group.events',
    component: EventsPage,
  },
  {
    state: 'group.members',
    component: MembersPage,
  },
  {
    state: 'group.custom.tab',
    component: CustomTabPage,
  },
];
